import React from "react";
import { ImageKit } from "@aph/ui-lib-humanx";
import { NEXT_PUBLIC_MOM_BABY_BASE_PATH, NEXT_PUBLIC_NODE_ENV } from "@/libs/constants/auth";
import { isURL } from "@/helpers";

interface ImageProps {
  src: any;
  alt: string | undefined;
  title?: string;
  width?: number;
  height?: number;
  onClick?: (e?: any) => void;
  imageWidthWithNoModification?: boolean;
  format?: string;
  eagerLoad?: boolean;
  className?: string;
  customStyle?: React.CSSProperties;
  fallbackImgSrc?: string;
  onLoad?: (e?: any) => void;
  thumbnailSecond?: number;
}

const Image: React.FC<ImageProps> = ({ src, ...props }) => {
  const newSrc = isURL(src)
    ? src
    : `${NEXT_PUBLIC_NODE_ENV !== "development" ? NEXT_PUBLIC_MOM_BABY_BASE_PATH : ""}${src}`;

  return <ImageKit src={newSrc} {...props} />;
};

export default Image;
